import React from  "react";

const Injury = (props) => {


   return (
      <section className="feature">
           <div className="feature-description">

                     
            <h1>Overcoming Severe Obstacles </h1>
            
            <li>2010 Back Fracture - three months in a back brace</li> 
            <li>2010 National Champion</li> 
            <div className="spacer feature-separator"></div>
            <li> April 2018 - State Champion</li>
            <li> May 10, 2018 - Shattered Right Foot at Regionals</li>
            <li>September 2018 - Started jumping again</li>
            <div className="spacer feature-separator"></div>
            <li> April 2019 - State Champion</li>
            <li> June 2019 - Grade II Right Ankle Sprain  </li>
            <li> July 2019 - National Championships - Silver Medalist</li>
            </div>

      </section>
   )
}
export default Injury;